module.exports = __webpack_public_path__ + "static/img/TL.fcac91fb.png";